<template>
  <div>
    <div ref="videoEditer"></div>
  </div>
</template>
<script>
import E from 'wangeditor';
export default {
  props: {
    jianjie: {
      type: String,
      default: ''
    },
    changeText: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      editor: null
    };
  },
  created () {
  },
  mounted () {
    var that = this;
    that.editor = new E(this.$refs.videoEditer);
    that.editor.config.menus = [
      'head',
      'bold',
      'fontSize',
      'fontName',
      'italic',
      'underline',
      'strikeThrough',
      'indent',
      'lineHeight',
      'foreColor',
      'link',
      'list',
      'justify',
      'undo',
      'redo'
    ];
    that.editor.config.onchange = function (newHtml) {
      that.changeText(newHtml)
    };
    that.editor.config.onchangeTimeout = 500;
    that.editor.create();
    that.editor.txt.html(this.jianjie)
  },
  methods: {
    clear () {
      this.editor.txt.html('')
    },
    toText () {
      this.editor.txt.html(this.jianjie)
    }
  }
};
</script>
<style>
</style>